<template>
  <div 
    v-if="isAfterOnePmAZ" 
    class="alert success"
  >
    <p class="w-72">
      * It's after {{ format(localTime, 'haaa') }}! Responses sent now may not get a response until tomorrow.
    </p>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { format, isAfter } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

const ARIZONA_TIMEZONE = 'America/Phoenix'

const localTime = ref<Date>(new Date())
const isAfterOnePmAZ = ref(false)

onMounted(() => {
  const now = new Date()

  // Get the current time in Arizona
  const arizonaTime = utcToZonedTime(now, ARIZONA_TIMEZONE)

  // Set Arizona 1 PM time for today
  const onePmArizona = new Date(arizonaTime.getFullYear(), arizonaTime.getMonth(), arizonaTime.getDate(), 13, 0)

  // Compare the current Arizona time to 1 PM Arizona time
  isAfterOnePmAZ.value = isAfter(arizonaTime, onePmArizona)

  // Display the local time of the user
  const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
  localTime.value = utcToZonedTime(now, userTimeZone)
})
</script>